export default "__VITE_ASSET__BaZ881fa__"